import { render, staticRenderFns } from "./DialogSendMessage.vue?vue&type=template&id=67a17e8a"
import script from "./DialogSendMessage.vue?vue&type=script&lang=js"
export * from "./DialogSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports